import React from 'react';
import { useSignatureValidation } from '../hooks/useSignatureValidation';
import LoadingPage from '../components/LoadingPage';
import LinkExpired from '../components/LinkExpired';

/**
 * Higher-Order Component for adding signature validation to any component
 * 
 * @param {React.Component} WrappedComponent - The component to wrap with validation
 * @returns {React.Component} - Enhanced component with signature validation
 */
export const withLinkValidation = (WrappedComponent) => {
    const WithLinkValidationComponent = (props) => {
        const { isValidating, isLinkValid, params } = useSignatureValidation();

        // Show loading while validating
        if (isValidating) {
            return <LoadingPage />;
        }

        // Show error if link is invalid
        if (!isLinkValid) {
            return <LinkExpired />;
        }

        // If validation passed, render the wrapped component
        // Pass the URLSearchParams as a prop for convenience
        return <WrappedComponent {...props} params={params} />;
    };

    // Set display name for better debugging
    WithLinkValidationComponent.displayName = `withLinkValidation(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

    return WithLinkValidationComponent;
};